import { FunctionComponent, PropsWithChildren, useEffect, useRef } from 'react';
import { useVideoContext } from '../../../../../hooks/use-video';

interface Props extends PropsWithChildren {
  sceneId: string;
  sceneItemIndex: number;
  openModal: () => void;
}

const SceneItemWrapper: FunctionComponent<Props> = ({
  sceneItemIndex,
  sceneId,
  openModal,
  children,
}) => {
  const { latestSceneItem, setLatestSceneItem } = useVideoContext();
  const containerRef = useRef<any>(null);

  useEffect(() => {
    if (!latestSceneItem) {
      return;
    }

    if (
      sceneId === latestSceneItem?.sceneId &&
      sceneItemIndex === latestSceneItem?.sceneItemIndex
    ) {
      openModal();
      setLatestSceneItem(null);

      if (containerRef && containerRef.current) {
        containerRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }
  }, []);

  return <div ref={containerRef}>{children}</div>;
};

export default SceneItemWrapper;
